export default __webpack_public_path__ + "bb137c7d30143bdcdb5e9624fea93530.svg";